import { render, staticRenderFns } from "./seamlessScroll.vue?vue&type=template&id=2724c74d&scoped=true&"
import script from "./seamlessScroll.vue?vue&type=script&lang=js&"
export * from "./seamlessScroll.vue?vue&type=script&lang=js&"
import style0 from "./seamlessScroll.vue?vue&type=style&index=0&id=2724c74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724c74d",
  null
  
)

export default component.exports